import * as yup from 'yup';

import { countryCodes } from 'app/constants/countries';

import { validateEmail } from 'app/utils/validations';

const checkEmail = yup.object().shape({
  email: yup
    .string()
    .required('Email is mandatory')
    .test('Invalid email', 'Enter a valid email', (value) => validateEmail(value)),
});

const userDetails = yup.object().shape({
  firstName: yup
    .string()
    .required('First name is mandatory')
    .min(2, 'First name should contain at least 2 letters')
    .matches(
      /^[a-zA-ZÀ-ÿ\s'.-]+$/,
      "First name should only contain letters, spaces, and symbols (.-')"
    ),
  lastName: yup
    .string()
    .required('Last name is mandatory')
    .min(2, 'Last name should contain at least 2 letters')
    .matches(
      /^[a-zA-ZÀ-ÿ\s'.-]+$/,
      "Last name should only contain letters, spaces, and symbols (.-')"
    ),
  password: yup
    .string()
    .required('Password is mandatory')
    .matches(
      /^(?!\s+)(?!.*\s+$)(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[$^*.[\]{}()?"!@#%&/\\,><':;|_~`=+\- ])[A-Za-z0-9$^*.[\]{}()?"!@#%&/\\,><':;|_~`=+\- ]{8,256}$/,
      'Your password must contain at least 8 characters, 1 uppercase letter, 1 number (0-9), 1 special character'
    ),
  confirmPassword: yup
    .string()
    .required('Confirm password is mandatory')
    .oneOf([yup.ref('password')], 'Passwords do not match'),
});

const enableTwoFactor = yup.object().shape({
  phoneNumber: yup
    .string()
    .phone(countryCodes, 'Enter a valid phone number')
    .required('Phone number is mandatory'),
});

const login = yup.object().shape({
  password: yup.string().required('You need to enter your password'),
});

const resetPassword = yup.object().shape({
  code: yup
    .string()
    .required('Verification code is mandatory')
    .length(6, 'Please enter the full verification code'),
  password: yup
    .string()
    .required('Password is mandatory')
    .matches(
      /^(?!\s+)(?!.*\s+$)(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[$^*.[\]{}()?"!@#%&/\\,><':;|_~`=+\- ])[A-Za-z0-9$^*.[\]{}()?"!@#%&/\\,><':;|_~`=+\- ]{8,256}$/,
      'Your password must contain at least 8 characters, 1 uppercase letter, 1 number (0-9), 1 special character'
    ),
  confirmPassword: yup
    .string()
    .required('Confirm password is mandatory')
    .oneOf([yup.ref('password')], 'Passwords do not match'),
});

const authenticationSchema = {
  checkEmail,
  userDetails,
  enableTwoFactor,
  login,
  resetPassword,
};

export default authenticationSchema;
